import React from "react";
import {IListViewField} from "../../../../Shared/ILIstViewField";
import {AppEntities} from "../../../../../config/entities";
import {NewDocumentListView} from "../../../../Shared/NewDocumentListView";

const GoodsTransfersOrdersList = () => {
    const fields: IListViewField[] = [
    ];

    return (
        <>
            <NewDocumentListView fields={fields} entity={AppEntities.GoodsTransfersOrders} />
        </>
    );
}

export default GoodsTransfersOrdersList;